import { render, staticRenderFns } from "./NonTransferablesTab.vue?vue&type=template&id=3c5a99e9&"
import script from "./NonTransferablesTab.vue?vue&type=script&lang=ts&"
export * from "./NonTransferablesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports